module.exports = __webpack_public_path__ + "img/BG-Networking.81636a8d.jpg";